import { render } from "./recentAssignments.vue?vue&type=template&id=3dff9303"
import script from "./recentAssignments.vue?vue&type=script&lang=js"
export * from "./recentAssignments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__